import { useEffect, useState } from 'react';
import useGetWeightedScores from './useGetWeightedScores';
import { useIsFeatureEnabled, useLocalStorage } from '@innovyze/stylovyze';
import { useRiskDetailsSelectors } from './useRiskDetailsSelectors';

export default function useGetRiskDetailsColumnVisibility(configId: string) {
	const weightedScores = useGetWeightedScores();
	const { tenantId, userId } = useRiskDetailsSelectors();

	const [cofFirstRender, setCofFirstRender] = useState(true);

	const isIndividualScoresEnabled = useIsFeatureEnabled(
		'info-360-risk-datagrid-individual-scores',
	);

	const [columnVisibilityModel, setColumnVisibilityModel] = useLocalStorage<
		Record<string, boolean> | undefined
	>(
		`${userId}.${tenantId}.riskTable.columnVisibilityModel.${configId}`,
		undefined,
	);

	const weightedCofColumnNames = weightedScores.cofScores
		?.map(cof => (cof.field.includes('Raw') ? cof.field : null))
		.filter(Boolean);
	const weightedLofColumnNames = weightedScores.lofScores
		.map(lof => lof.field)
		.filter(Boolean);

	useEffect(() => {
		if (
			isIndividualScoresEnabled &&
			!columnVisibilityModel &&
			cofFirstRender &&
			(weightedCofColumnNames.length > 0 ||
				weightedLofColumnNames.length > 0)
		) {
			const cof = weightedCofColumnNames
				.filter(el => el?.includes('Raw'))
				.map(el => ({ [el ?? '']: false }));

			const lof = weightedLofColumnNames
				.filter(el => el?.includes('Raw'))
				.map(el => ({ [el.toString()]: false }));

			const joined = [...cof, ...lof].reduce(
				(acc, val) => ({ ...acc, ...val }),
				{},
			) as Record<string, boolean>;

			setColumnVisibilityModel(cvm => ({ ...cvm, ...joined }));
			setCofFirstRender(false);
		}
	}, [weightedScores.cofScores, weightedScores.lofScores]);

	return { columnVisibilityModel, setColumnVisibilityModel };
}
